import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { useAppDispatch } from '@/store/hooks.ts';
import { onConfirmRemoveSharedTab } from '@/store/tabs/slice.ts';

interface DeleteSharedTabModalProps {
  tabId: string;
  show: boolean;
  close: () => void;
}

export function DeleteSharedTabModal({ tabId, show, close }: DeleteSharedTabModalProps) {
  const dispatch = useAppDispatch();

  const onClickConfirm = () => dispatch(onConfirmRemoveSharedTab(tabId));

  return (
    <Modal show={show} onHide={close}>
      <ModalHeader>
        <ModalTitle>
          <FormattedMessage id="delete-shared-tab-modal.title" />
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <FormattedMessage id="delete-shared-tab-modal.description" />
      </ModalBody>
      <ModalFooter>
        <Button variant="outline-primary" onClick={close}>
          <FormattedMessage id="delete-shared-tab-modal.cancel-button" />
        </Button>
        <Button onClick={onClickConfirm} data-e2e="delete-shared-tab-confirm-button">
          <FormattedMessage id="delete-shared-tab-modal.confirm-button" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
